import {
  Component,
  EventEmitter,
  Input,
  Output,
  computed,
  inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Resolution } from '@api-types/enums/resolution.enum';
import { FormFieldComponent, FormInputSelectComponent } from '@libs/ui';
import { Store } from '@ngrx/store';
import { ResolutionService } from 'demand-forecasting/services/resolution.service';
import { ConfigurationsSelectors } from 'demand-forecasting/store/configurations/configurations.selectors';

@Component({
  selector: 'pm-resolution-picker',
  template: `
    <pm-form-field class="block w-full" label="RESULT.SIDEBAR.RESOLUTION.TITLE">
      <pm-form-input-select
        [ngModel]="resolution"
        [data]="availableResolutions()"
        (ngModelChange)="changeResolution($event)"
      />
    </pm-form-field>
  `,
  imports: [FormsModule, FormFieldComponent, FormInputSelectComponent],
})
export class ResolutionPickerComponent {
  @Input() resolution: Resolution | undefined;
  @Output() resolutionChange = new EventEmitter<Resolution>();

  private readonly store = inject(Store);
  private readonly resolutionService = inject(ResolutionService);
  private readonly configuration = this.store.selectSignal(
    ConfigurationsSelectors.selectConfigurationByUrlParam,
  );

  protected availableResolutions = computed(() => {
    const configuration = this.configuration();
    if (configuration) {
      return this.resolutionService.getResolutionOptionsByConfiguration(
        configuration,
      );
    }
    return [];
  });

  changeResolution(
    resolution: Resolution | (Resolution | undefined)[] | undefined,
  ) {
    if (!resolution) {
      return;
    }
    if (Array.isArray(resolution)) {
      return;
    }

    this.resolutionChange.emit(resolution);
  }
}
